import { LogIn, ShoppingCart, Wallet, Receipt, PackageCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: LogIn,
    title: "Sign up",
    body: "Register on our website for a 10% discount on your first order.",
  },
  {
    n: "02",
    icon: ShoppingCart,
    title: "Shop",
    body: "Add your desired products to your cart. More quantities mean extra discounts.",
  },
  {
    n: "03",
    icon: Wallet,
    title: "Checkout",
    body: "Choose your payment method at checkout. We accept Bank Transfer, Wise, or Remitly. Credit card payments are also possible via Wise or Remitly.",
  },
  {
    n: "04",
    icon: Receipt,
    title: "Make payment",
    body: "Transfer the payment and share your payment proof via our website, email, or WhatsApp. Include your order number.",
  },
  {
    n: "05",
    icon: PackageCheck,
    title: "Receive products",
    body: "Await the confirmation and delivery of your products.",
  },
];

export const FastShopping = () => {
  return (
    <section
      className="py-24 md:py-32 bg-white border-t border-neutral-200"
      data-testid="fast-shopping-section"
    >
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="mb-14 max-w-3xl">
          <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-4 font-medium">
            Fast shopping process
          </div>
          <h2 className="font-heading leading-[0.95] tracking-tight">
            <span className="block text-4xl md:text-6xl font-black">From cart to clinic,</span>
            <span className="block text-4xl md:text-6xl font-thin">in five steps.</span>
          </h2>
          <p className="mt-5 text-base text-neutral-600 font-light max-w-xl">
            The full process to quickly place your order from A to Z — no friction, no waiting on a sales rep.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-neutral-200 border border-neutral-200">
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.n}
                className="group relative bg-white p-7 md:p-8 flex flex-col gap-6 hover:bg-neutral-50 transition-colors duration-300"
                data-testid={`step-card-${s.n}`}
              >
                {/* Step number — top right */}
                <div className="absolute top-5 right-5 text-[10px] tracking-[0.3em] uppercase font-bold text-[#FF5A1F]">
                  Step {s.n}
                </div>

                {/* Icon block with accent dot */}
                <div className="relative w-14 h-14 mt-2 flex items-start" data-testid={`step-icon-${s.n}`}>
                  <Icon
                    className="w-12 h-12 text-neutral-900 relative z-10"
                    strokeWidth={1.4}
                  />
                  <span
                    aria-hidden="true"
                    className="absolute -top-1 left-3 w-6 h-6 rounded-full bg-[#1554F0] opacity-90 group-hover:scale-110 transition-transform duration-300"
                  />
                </div>

                {/* Title */}
                <h3 className="font-heading text-lg md:text-xl font-black tracking-[0.08em] uppercase text-neutral-900">
                  {s.title}
                </h3>

                {/* Divider rule under title */}
                <span className="block w-10 h-px bg-neutral-300 -mt-3" aria-hidden="true" />

                {/* Body */}
                <p className="text-sm leading-relaxed text-neutral-600 font-light">
                  {s.body}
                </p>

                {/* Bottom accent line — appears on hover */}
                <span
                  aria-hidden="true"
                  className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#1554F0] group-hover:w-full transition-all duration-500"
                />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
